export default {
  "content": "<path d=\"M14.7 1.604l-.789-.267c-.018-.007-.036-.018-.056-.024l-2.36-.816c-.031-.008-.062-.009-.092-.015l-.21-.071a1.993 1.993 0 00-1.036-.017L5.44 1.6c-.134-.033-.29-.067-.462-.125L3.086.839c-.007 0-.014 0-.02-.005L1.896.44a.933.933 0 00-1.23.885v10.189a.933.933 0 00.632.883l.52.177c.026.01.05.024.078.034l2.34.819.037.01c.047.01.094.017.142.02l.39.134c.338.097.696.103 1.037.017l4.8-1.209 1.806.607 1.655.556a.933.933 0 001.23-.884V2.487a.933.933 0 00-.633-.883zM6 2.817l4-1.008v9.375l-4 1.008V2.816z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "16",
    "height": "14",
    "viewBox": "0 0 16 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};